class NavMobileMenu {
    constructor() {
        this.navMobileMenu = document.querySelector('.navbar-menu-bar-mobile');
        this.navMobileToggle = document.querySelector('.js-navbar-menu-bar-burger');
        this.proxyNavMobileToggle =  document.querySelector('.js-navbar-menu-bar-burger-mobile');
    }

    init() {
        if (this.navMobileMenu !== null) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.navMobileToggle.addEventListener('click', () => {
            this.toggleNavMobileMenu();
        });

        this.proxyNavMobileToggle.addEventListener('click', () => {
            this.toggleNavMobileMenu();
        });
    }

    toggleNavMobileMenu() {
        this.navMobileToggle.classList.toggle('is-active');
        this.navMobileMenu.classList.toggle('is-hidden');

        document.documentElement.classList.toggle('is-clipped');
    }
}

export default new NavMobileMenu();